import { loadState, persistState } from "../../utils/localStorage";
import { ActionTypes } from "../types";

const initialState = null;
const savedState = loadState("squadSubmission");

export const squadSubmissionReducer = (
  state = savedState ? savedState : initialState,
  action
) => {
  switch (action.type) {
    case ActionTypes.SET_SQUAD_SUBMISSION:
      const { squadSubmission } = action.payload;
      const newState = squadSubmission;
      persistState("squadSubmission", newState);
      if (squadSubmission) trackSubmission(squadSubmission);
      return newState;

    default:
      return state;
  }
};

function trackSubmission(squadSubmission) {
  (window as any).analytics?.track("Squad Submit", {
    entry_id: squadSubmission.entryId,
    email: squadSubmission.email,
    name: squadSubmission.name,
    created_at: squadSubmission.created_at,
    theater_name: squadSubmission.theater_name,
    squad_submitted: squadSubmission.squad,
  });
}
